import {
  FETCH_FORM_FIELDS_REQUEST,
  FETCH_FORM_FIELDS_SUCCESS,
  FETCH_FORM_FIELDS_ERROR,
  CLEAR_FORM_FIELDS
} from './actions';

const initialState = {
  formFields: {}, // { formId: { fields: [], loading: false, error: null } }
  currentFormId: null,
};

export default function formFieldSelectorReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FORM_FIELDS_REQUEST:
      return {
        ...state,
        currentFormId: action.payload.formId,
        formFields: {
          ...state.formFields,
          fetchListFieldsFormModels: true,
          [action.payload.formId]: {
            fields: [],
            loading: true,
            error: null
          }
        }
      };

    case FETCH_FORM_FIELDS_SUCCESS:
      return {
        ...state,
        formFields: {
          ...state.formFields,
          fetchListFieldsFormModels: false,
          [action.payload.formId]: {
            fields: action.payload.fields,
            loading: false,
            error: null
          }
        }
      };

    case FETCH_FORM_FIELDS_ERROR:
      return {
        ...state,
        formFields: {
          ...state.formFields,
          fetchListFieldsFormModels: false,
          [action.payload.formId]: {
            fields: [],
            loading: false,
            error: action.payload.error
          }
        }
      };

    case CLEAR_FORM_FIELDS:
      return {
        ...state,
        formFields: {},
        currentFormId: null
      };

    default:
      return state;
  }
} 